import React from 'react';
import { cn } from '../../lib/utils';
import { PERIODS } from '../../lib/tradeUtils';

export function PeriodSelector({ value, onChange, label }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      {label ? <div className="font-heading text-lg font-semibold text-white" data-testid="period-label">{label}</div> : <span />}
      <div className="inline-flex rounded-lg border border-white/10 bg-ink-surface p-1">
        {PERIODS.map((p) => {
          const active = value === p.key;
          return (
            <button
              key={p.key}
              onClick={() => onChange(p.key)}
              data-testid={`period-${p.key}`}
              className={cn(
                'rounded-md px-3 py-1.5 text-xs font-semibold transition-colors',
                active ? 'bg-emerald text-black' : 'text-zinc-400 hover:text-white'
              )}
            >
              {p.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
